import { render, staticRenderFns } from "./Names.vue?vue&type=template&id=50b21e69&scoped=true"
import script from "./Names.vue?vue&type=script&lang=js"
export * from "./Names.vue?vue&type=script&lang=js"
import style0 from "./Names.vue?vue&type=style&index=0&id=50b21e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b21e69",
  null
  
)

export default component.exports